"use strict";
import angular from "angular";
import tritonListenerTargetingHtmlUrl from "./views/tritonListenerTargeting.html";
import "../tritonGeoTargeting/tritonGeo.component";

let app = angular.module("app.tritonListenerTargeting.component", []);

app.component("tritonListenerTargeting", {
  bindings: {
    showActions: "=",
    sets: "=",
    clusterId: "=",
    model: "=",
    selectedGeoLocations: "=",
  },
  templateUrl: tritonListenerTargetingHtmlUrl,

  controller: function (
      $rootScope,
      $scope
  ) {
    var self = this;
    self.isMainDialogOpen = false;
    self.isAgeDialogOpen = false;
    self.isGenderDialogOpen = false;
    self.isGeoDialogOpen = false;
    self.ageRule = "is";
    self.ageValue = "";
    self.ageValueLower = "";
    self.ageValueUpper = "";
    self.ageError = "";
    self.ageChips = [];
    self.tempAgeChips = [];
    self.matchType = true;
    self.isSummaryView = false;
    self.selectedGenders = {
      male: false,
      female: false,
      other: false,
    };
    self.genderChips = [];
    self.tempGenderChips = [];
    self.summaryOrder = [];
    self.geoChips = [];
    self.tempGeoChips = [];
    self.tempRuleSets = [{
      tempGenderChips: [],
      tempAgeChips: [],
      tempGeoChips: [],
      ageMatchType: true,
      genderMatchType: true,
      geoMatchType: true
    }];
    self.ruleSets = [{
      genderChips: [],
      ageChips: [],
      geoChips: [],
      ageMatchType: true,
      genderMatchType: true,
      geoMatchType: true
    }];
    self.currentRuleSetIndex = 0;

    // ************ Dialog controls ******************

    self.openMainDialog = () => (self.isMainDialogOpen = true);

    self.openAgeDialog = () => {
      self.isAgeDialogOpen = true;
      self.isMainDialogOpen = false;
      self.copyAllRuleSetsToTemp();

      const tempRuleSet = self.tempRuleSets[self.currentRuleSetIndex];
      if (tempRuleSet.tempAgeChips && tempRuleSet.tempAgeChips.length > 0) {
        tempRuleSet.ageMatchType = tempRuleSet.tempAgeChips[0].match;
      } else {
        tempRuleSet.ageMatchType = true;
      }
    };

    self.openGenderDialog = () => {
      self.copyAllRuleSetsToTemp();

      const tempRuleSet = self.tempRuleSets[self.currentRuleSetIndex];
      tempRuleSet.selectedGenders = { male: false, female: false, other: false };
      if (tempRuleSet.tempGenderChips && tempRuleSet.tempGenderChips.length > 0) {
        tempRuleSet.genderMatchType = tempRuleSet.tempGenderChips[0].match;
      } else {
        tempRuleSet.genderMatchType = true;
      }

      (tempRuleSet.genderChips || []).forEach((chip) => {
        const genderKey = chip.value.toLowerCase();
        tempRuleSet.selectedGenders[genderKey] = true;
      });

      self.isGenderDialogOpen = true;
      self.isMainDialogOpen = false;
    };

    self.openGeoDialog = function () {
      self.isGeoDialogOpen = true;
      self.isMainDialogOpen = false;
      self.copyAllRuleSetsToTemp();

      const tempRuleSet = self.tempRuleSets[self.currentRuleSetIndex];

      if (tempRuleSet.tempGeoChips && tempRuleSet.tempGeoChips.length > 0) {
        tempRuleSet.geoMatchType = tempRuleSet.tempGeoChips[0].match;
      } else {
        tempRuleSet.geoMatchType = true;
      }
    };

    self.closeMainDialog = () => (self.isMainDialogOpen = false);

    self.closeAgeDialog = () => {
      self.resetAgeValues();
      self.isAgeDialogOpen = false;

      const tempRuleSet = self.tempRuleSets[self.currentRuleSetIndex];
      const ruleSet = self.ruleSets[self.currentRuleSetIndex];

      if (self.summaryOrder.includes("Age")) {
        self.isSummaryView = true;
      } else {
        ruleSet.ageChips = [];
        self.isSummaryView = self.summaryOrder.length > 0;
      }

      self.copyAllRuleSetsToTemp();
    };

    self.closeGenderDialog = () => {
      const tempRuleSet = self.tempRuleSets[self.currentRuleSetIndex];
      const ruleSet = self.ruleSets[self.currentRuleSetIndex];

      if (tempRuleSet && tempRuleSet.tempGenderChips) {
        tempRuleSet.tempGenderChips.forEach((chip) => {
          const genderValue = chip.value.toLowerCase();

          if (genderValue === "male") {
            tempRuleSet.selectedGenders.male = false;
          } else if (genderValue === "female") {
            tempRuleSet.selectedGenders.female = false;
          } else if (genderValue === "other") {
            tempRuleSet.selectedGenders.other = false;
          }
        });
      }

      self.isGenderDialogOpen = false;

      if (self.summaryOrder.includes("Gender")) {
        self.isSummaryView = true;
      } else {
        if (ruleSet) {
          ruleSet.genderChips = [];
        }
        self.isSummaryView = self.summaryOrder.length > 0;
      }
    };

    self.closeGeoDialog = function () {
      const ruleSet = self.ruleSets[self.currentRuleSetIndex];

      self.isGeoDialogOpen = false;
      self.isMainDialogOpen = false;

      if (self.summaryOrder.includes("Geo")) {
        self.isSummaryView = true;
      } else {
        ruleSet.geoChips = [];
        self.isSummaryView = self.summaryOrder.length > 0;
      }
      self.removeExtraGeoChips();
    };

    self.closeDialog = function (dialogType) {
      const tempRuleSet = self.tempRuleSets[self.currentRuleSetIndex];
      const ruleSet = self.ruleSets[self.currentRuleSetIndex];

      if (dialogType === "age") {
        self.closeAgeDialog();
      }

      if (dialogType === "gender") {
        self.closeGenderDialog();

        if (tempRuleSet && tempRuleSet.tempGenderChips) {
          tempRuleSet.tempGenderChips.forEach((chip) => {
            const genderValue = chip.value.toLowerCase();
            if (genderValue === "male") {
              tempRuleSet.selectedGenders.male = false;
            } else if (genderValue === "female") {
              tempRuleSet.selectedGenders.female = false;
            } else if (genderValue === "other") {
              tempRuleSet.selectedGenders.other = false;
            }
          });
        }

        self.copyAllRuleSetsToTemp();
      }

      if (dialogType === "geo") {
        self.closeGeoDialog();
        self.removeExtraGeoChips();
        self.copyAllRuleSetsToTemp();
        $rootScope.selectedGeoLocations.selAdwordsLocationPickers =
            ($rootScope.selectedGeoLocations.selAdwordsLocationPickers || []).filter((locationPicker) => {
              return ruleSet.geoChips.some((chip) => {
                const cleanedValue = chip.value.replace(/\s*\(.*?\)/, "").trim();
                return (
                    locationPicker.country_code === chip.country_code &&
                    locationPicker.type === chip.type &&
                    locationPicker.name === cleanedValue
                );
              });
            });
      }
    };

    self.closeAllDialogs = () => {
      self.isMainDialogOpen = false;
      self.isAgeDialogOpen = false;
    };

    $scope.$watch(
        () => self.ruleSets,
        function () {
          const hasChips = self.ruleSets.some(ruleSet =>
              (ruleSet.ageChips && ruleSet.ageChips.length) ||
              (ruleSet.genderChips && ruleSet.genderChips.length) ||
              (ruleSet.geoChips && ruleSet.geoChips.length)
          );

          if (!hasChips) {
            self.summaryOrder = [];
          }
        },
        true
    );

    self.getVisibleKeysForSet = function (ruleSet) {
      return self.summaryOrder.filter(function (key) {
        return (key === 'Age' && ruleSet.ageChips.length) ||
            (key === 'Gender' && ruleSet.genderChips.length) ||
            (key === 'Geo' && ruleSet.geoChips.length);
      });
    };

    self.goBackToMain = () => {
      self.isAgeDialogOpen = false;
      self.isMainDialogOpen = true;
      self.isGenderDialogOpen = false;
      self.isGeoDialogOpen = false;
    };

    // Reset age input values
    self.resetAgeValues = () => {
      self.ageValue = "";
      self.ageValueLower = "";
      self.ageValueUpper = "";
      self.ageError = "";
    };

    self.addAge = () => {
      const tempRuleSet = self.tempRuleSets[self.currentRuleSetIndex];

      if (!tempRuleSet) {
        console.error("No tempRuleSet found for currentRuleSetIndex");
        return;
      }

      if (self.ageRule === "between") {
        if (!self.ageValueLower || !self.ageValueUpper) {
          self.ageError = "Both lower and upper limits are required.";
          return;
        }

        const lowerValue = parseInt(self.ageValueLower, 10);
        const upperValue = parseInt(self.ageValueUpper, 10);

        if (
            isNaN(lowerValue) ||
            isNaN(upperValue) ||
            lowerValue < 1 ||
            upperValue > 125 ||
            lowerValue >= upperValue
        ) {
          self.ageError =
              "Invalid range. Ensure lower limit is less than upper limit, and both are between 1 and 125.";
          return;
        }

        const range = `${lowerValue}-${upperValue}`;

        if (
            tempRuleSet.tempAgeChips.some(
                (chip) => chip.value === range && chip.match === self.matchType
            )
        ) {
          self.ageError = "Duplicate range is not allowed.";
          return;
        }

        tempRuleSet.tempAgeChips.push({
          value: range,
          match: self.matchType,
          rule: "between",
        });
      } else {
        if (!self.ageValue) {
          self.ageError = "Age value is required.";
          return;
        }

        const numValue = parseInt(self.ageValue, 10);

        if (isNaN(numValue) || numValue < 1 || numValue > 125) {
          self.ageError = "Invalid age value. Enter a number between 1 and 125.";
          return;
        }

        if (
            tempRuleSet.tempAgeChips.some(
                (chip) => chip.value === String(numValue) && chip.match === self.matchType
            )
        ) {
          self.ageError = "Duplicate age value is not allowed.";
          return;
        }

        tempRuleSet.tempAgeChips.push({
          value: String(numValue),
          match: self.matchType,
          rule: self.ageRule,
        });
      }

      // Clear error after successful add
      self.ageError = "";
    };

    self.removeChip = (index) => {
      const tempRuleSet = self.tempRuleSets[self.currentRuleSetIndex];

      if (!tempRuleSet || !tempRuleSet.tempGenderChips) return;

      const chip = tempRuleSet.tempGenderChips[index];

      if (chip) {
        // Reset checkbox based on chip value
        const value = chip.value.toLowerCase();
        if (value === "male") {
          tempRuleSet.selectedGenders.male = false;
        } else if (value === "female") {
          tempRuleSet.selectedGenders.female = false;
        } else if (value === "other") {
          tempRuleSet.selectedGenders.other = false;
        }

        self.tempAgeChips.splice(index, 1);
        tempRuleSet.tempGenderChips.splice(index, 1);
      }
    };

    self.clearAgeChips = () => {
      const tempRuleSet = self.tempRuleSets[self.currentRuleSetIndex];

      if (tempRuleSet) {
        tempRuleSet.tempAgeChips = [];
      }

      if (self.summaryOrder.includes("Age")) {
        self.isSummaryView = true;
      } else {
        self.isSummaryView = self.summaryOrder.length > 0;
      }
    };

    self.clearGenderChips = () => {
      const tempRuleSet = self.tempRuleSets[self.currentRuleSetIndex];
      if (!tempRuleSet) return;

      tempRuleSet.tempGenderChips = [];
      self.selectedGenders = { male: false, female: false, other: false };

      self.isSummaryView = self.summaryOrder.includes("Gender") || self.summaryOrder.length > 0;
    };

    // Clear all Geo Chips
    self.clearGeoChips = function () {
      self.tempGeoChips = [];

      if (self.summaryOrder.includes("Geo")) {
        self.isSummaryView = true;
      } else {
        self.isSummaryView = self.summaryOrder.length > 0;
      }

      if (
          $rootScope.selectedGeoLocations &&
          $rootScope.selectedGeoLocations.selAdwordsLocationPickers
      ) {
        $rootScope.selectedGeoLocations.selAdwordsLocationPickers = [];
      }

      if (
          self.selectedTritonListenerTargeting &&
          self.selectedTritonListenerTargeting.rules
      ) {
        const geoRuleBlockIndex =
            self.selectedTritonListenerTargeting.rules.fields.findIndex(
                (field) =>
                    field.fields &&
                    field.fields.some(
                        (subField) =>
                            subField.fields &&
                            subField.fields.some((rule) => rule.dimension === "geo")
                    )
            );

        if (geoRuleBlockIndex !== -1) {
          self.selectedTritonListenerTargeting.rules.fields.splice(
              geoRuleBlockIndex,
              1
          );
        }
      }
    };

    self.setMatch = (type) => {
      const tempRuleSet = self.tempRuleSets[self.currentRuleSetIndex];
      if (!tempRuleSet) return;

      tempRuleSet.ageMatchType = type;
      tempRuleSet.tempAgeChips = tempRuleSet.tempAgeChips.map((chip) => ({
        ...chip,
        match: type,
      }));
    };

    self.setGenderMatch = (type) => {
      const tempRuleSet = self.tempRuleSets[self.currentRuleSetIndex];
      if (!tempRuleSet) return;

      tempRuleSet.genderMatchType = type;
      tempRuleSet.tempGenderChips = tempRuleSet.tempGenderChips.map((chip) => ({
        ...chip,
        match: type,
      }));
    };

    self.setGeoMatch = function (type) {
      const tempRuleSet = self.tempRuleSets[self.currentRuleSetIndex];
      if (!tempRuleSet || !tempRuleSet.tempGeoChips) return;

      tempRuleSet.geoMatchType = type;
      tempRuleSet.tempGeoChips = tempRuleSet.tempGeoChips.map((chip) => ({
        ...chip,
        match: type,
      }));
    };

    self.getFormattedChipText = (chip, key) => {
      // Check if the chip is for gender
      if (key === "Gender") {
        return chip.value; // Return the gender value directly (e.g., 'Male', 'Female', 'Other')
      }

      // Format for age chips
      if (key === "Age") {
        switch (chip.rule) {
          case "is":
            return chip.value;
          case "lte":
            return `<= ${chip.value}`;
          case "gte":
            return `>= ${chip.value}`;
          case "between":
            const values = chip.value.split("-");
            return `${values[0]} - ${values[1]}`;
          default:
            return chip.value;
        }
      }

      // Default behavior for other keys (like geoChips)
      return chip.value;
    };

    self.addAgeRule = function () {
      const tempRuleSet = self.tempRuleSets[self.currentRuleSetIndex];
      const ruleSet = self.ruleSets[self.currentRuleSetIndex];

      if (!tempRuleSet || !ruleSet) return;

      if (tempRuleSet.tempAgeChips.length > 0) {
        self.copyAllTempRuleSetsToMain();
      }

      if (ruleSet.ageChips.length > 0) {
        const hasNegativeMatch = ruleSet.ageMatchType === false;

        const processedAgeRules = ruleSet.ageChips
            .map((chip) => {
              switch (chip.rule) {
                case "is":
                  return {
                    dimension: "age",
                    type: "equals",
                    value: chip.value.toString(),
                  };
                case "between":
                  const [lower, upper] = chip.value.split("-").map(Number);
                  return {
                    dimension: "age",
                    type: "bound",
                    lower,
                    upper,
                  };
                case "lte":
                  return {
                    dimension: "age",
                    type: "bound",
                    upper: parseInt(chip.value, 10),
                  };
                case "gte":
                  return {
                    dimension: "age",
                    type: "bound",
                    lower: parseInt(chip.value, 10),
                  };
                default:
                  return null;
              }
            })
            .filter(Boolean);

        if (!self.summaryOrder.includes("Age")) {
          self.summaryOrder.push("Age");
        }
        const index = self.currentRuleSetIndex;
        const orFields = self.selectedTritonListenerTargeting?.rules?.fields;

        if (
            self.selectedTritonListenerTargeting &&
            self.selectedTritonListenerTargeting.rules &&
            Array.isArray(orFields) &&
            orFields[index] &&
            Array.isArray(orFields[index].fields)
        ) {
          orFields[index].fields = cleanRules(orFields[index].fields);
        }

        function cleanRules(fields) {
          return fields.filter((rule) => {
            if (rule.dimension === "age") {
              return false;
            }
            if (rule.type === "not" && rule.field) {
              rule.field.fields = cleanRules(rule.field.fields || []);
              if (!rule.field.fields.length) return false;
            }
            if (rule.fields && rule.fields.length > 0) {
              rule.fields = cleanRules(rule.fields);
            }
            return !(rule.fields && rule.fields.length === 0);
          });
        }

        self.updateTargetingPayload("age", {
          values: processedAgeRules,
          negativeMatch: hasNegativeMatch,
        });

        self.isAgeDialogOpen = false;
        self.isSummaryView = true;
      }
    };

    self.addGenderRule = function () {
      const tempRuleSet = self.tempRuleSets[self.currentRuleSetIndex];
      const ruleSet = self.ruleSets[self.currentRuleSetIndex];

      if (!tempRuleSet || !ruleSet) return;

      if (tempRuleSet.tempGenderChips && tempRuleSet.tempGenderChips.length > 0) {
        self.copyAllTempRuleSetsToMain();
      }

      if (!self.summaryOrder.includes("Gender")) {
        self.summaryOrder.push("Gender");
      }

      const index = self.currentRuleSetIndex;
      const orFields = self.selectedTritonListenerTargeting?.rules?.fields;

      if (
          self.selectedTritonListenerTargeting &&
          self.selectedTritonListenerTargeting.rules &&
          Array.isArray(orFields) &&
          orFields[index] &&
          Array.isArray(orFields[index].fields)
      ) {
        orFields[index].fields = cleanRules(orFields[index].fields);
      }

      function cleanRules(fields) {
        return fields.filter((rule) => {
          if (rule.dimension === "gender") {
            return false;
          }
          if (rule.type === "not" && rule.field) {
            rule.field.fields = cleanRules(rule.field.fields || []);
            if (!rule.field.fields.length) return false;
          }
          if (rule.fields && rule.fields.length > 0) {
            rule.fields = cleanRules(rule.fields);
          }
          return !(rule.fields && rule.fields.length === 0);
        });
      }

      if (ruleSet.genderChips && ruleSet.genderChips.length > 0) {
        const hasNegativeMatch = ruleSet.genderMatchType === false;
        const genderValues = ruleSet.genderChips.map((chip) =>
            chip.value.charAt(0).toLowerCase()
        );

        self.updateTargetingPayload("gender", {
          values: genderValues,
          negativeMatch: hasNegativeMatch,
        });
      }

      // Close dialog
      self.closeGenderDialog();
      self.isSummaryView = true;
    };

    self.addGeoRule = function () {
      const tempRuleSet = self.tempRuleSets[self.currentRuleSetIndex];
      const ruleSet = self.ruleSets[self.currentRuleSetIndex];

      if (!tempRuleSet || !ruleSet) return;

      if (tempRuleSet.tempGeoChips && tempRuleSet.tempGeoChips.length > 0) {
        self.copyAllTempRuleSetsToMain();
      }

      if (ruleSet.geoChips.length > 0) {
        const hasNegativeMatch = ruleSet.geoMatchType === false;

        const geoValuesByDimension = ruleSet.geoChips.reduce((acc, chip) => {
          const dimension =
              chip.type === "country"
                  ? "country"
                  : chip.type === "region"
                      ? "region-iso"
                      : chip.type === "city"
                          ? "city-geonames-id"
                          : null;

          if (dimension) {
            if (!acc[dimension]) acc[dimension] = [];
            const value =
                chip.type === "country"
                    ? chip.country_code
                    : chip.type === "region"
                        ? chip.code
                        : chip.value_num;

            if (!acc[dimension].includes(value)) {
              acc[dimension].push(value);
            }
          }

          return acc;
        }, {});

        const processedGeoRules = Object.entries(geoValuesByDimension).map(
            ([dimension, values]) => ({
              type: "in",
              dimension: dimension,
              values: values,
            })
        );

        if (!self.summaryOrder.includes("Geo")) {
          self.summaryOrder.push("Geo");
        }

        self.updateTargetingPayload("geo", {
          values: processedGeoRules,
          negativeMatch: hasNegativeMatch,
        });

        self.closeGeoDialog();
        self.isSummaryView = true;
      }
    };

    self.updateTargetingPayload = function (ruleType, ruleData) {
      if (
          !self.selectedTritonListenerTargeting ||
          Object.keys(self.selectedTritonListenerTargeting).length === 0
      ) {
        self.selectedTritonListenerTargeting = {
          targeting_type: "listener",
          rules: {
            type: "or",
            fields: [],
          },
        };
      }

      if (!ruleData || !ruleData.values || ruleData.values.length === 0) return;

      let coreRule;
      if (ruleType === "age") {
        coreRule = {
          type: "or",
          fields: ruleData.values,
        };
      } else if (ruleType === "gender") {
        coreRule = {
          type: "in",
          dimension: "gender",
          values: ruleData.values,
        };
      } else if (ruleType === "geo") {
        coreRule = {
          type: "or",
          fields: ruleData.values,
        };
      } else {
        return;
      }

      const wrappedRule = ruleData.negativeMatch
          ? { type: "not", field: coreRule }
          : coreRule;

      const finalRule = {
        type: "and",
        fields: [wrappedRule],
      };

      const orFields = self.selectedTritonListenerTargeting.rules.fields;
      const index = self.currentRuleSetIndex;

      if (!orFields[index]) {
        orFields[index] = {
          type: "and",
          fields: [],
        };
      }

      orFields[index].fields = orFields[index].fields.filter(
          (field) => !containsDimension(field, ruleType)
      );

      orFields[index].fields.push(finalRule);

      self.selectedTritonListenerTargeting.selectedGeoLocations =
          $rootScope.selectedGeoLocations
              ? $rootScope.selectedGeoLocations.selAdwordsLocationPickers
              : undefined;

      self.sets = JSON.stringify(self.selectedTritonListenerTargeting, null, 2);

      function containsDimension(field, dim) {
        if (field.dimension === dim) return true;
        if (field.field) return containsDimension(field.field, dim);
        if (field.fields && field.fields.length) {
          return field.fields.some((f) => containsDimension(f, dim));
        }
        return false;
      }
    };

    self.addAgeRuleAndContinue = () => {
      self.addAgeRule();
      self.closeAgeDialog();
      self.goBackToMain();
    };

    self.addGenderRuleAndContinue = () => {
      self.addGenderRule(); // Add the gender rule
      self.closeGenderDialog(); // Close the gender dialog
      self.goBackToMain(); // Go back to the main dialog
    };

    self.addGeoRuleAndContinue = () => {
      self.addGeoRule(); // Add the geo rule
      self.closeGeoDialog(); // Close the geo dialog
      self.goBackToMain(); // Go back to the main dialog
    };

    // Watch for changes in ageRule to reset values if needed
    $scope.$watch("ageRule", (newRule) => {
      if (newRule === "between") {
        self.resetAgeValues();
      } else {
        self.ageValueLower = "";
        self.ageValueUpper = "";
      }
    });

    self.showSummaryView = () => {
      self.isSummaryView = true;
      self.isMainDialogOpen = false;
      self.isAgeDialogOpen = false;
    };

    self.cancelKey = function (key, ruleSetIndex) {
      const ruleSet = self.ruleSets[ruleSetIndex];
      const orFields = self.selectedTritonListenerTargeting.rules.fields;

      // Reset chips
      if (key === "Age") {
        ruleSet.ageChips = [];

        if (orFields[ruleSetIndex]) {
          orFields[ruleSetIndex].fields = orFields[ruleSetIndex].fields.filter(
              (field) => !containsDimension(field, "age")
          );
        }

      } else if (key === "Gender") {
        ruleSet.genderChips = [];

        if (orFields[ruleSetIndex]) {
          orFields[ruleSetIndex].fields = orFields[ruleSetIndex].fields.filter(
              (field) => !containsDimension(field, "gender")
          );
        }

      } else if (key === "Geo") {
        ruleSet.geoChips = [];

        if (
            $rootScope.selectedGeoLocations &&
            $rootScope.selectedGeoLocations.selAdwordsLocationPickers
        ) {
          $rootScope.selectedGeoLocations.selAdwordsLocationPickers = [];
        }

        self.selectedTritonListenerTargeting.selectedGeoLocations = {};

        if (orFields[ruleSetIndex]) {
          orFields[ruleSetIndex].fields = orFields[ruleSetIndex].fields.filter(
              (field) => !containsGeo(field)
          );
        }
      }

      // Clean up empty ruleSet fields if needed
      if (
          orFields[ruleSetIndex] &&
          orFields[ruleSetIndex].fields.length === 0
      ) {
        orFields.splice(ruleSetIndex, 1);
        self.ruleSets.splice(ruleSetIndex, 1);
      }

      // Update sets string
      self.sets = JSON.stringify(self.selectedTritonListenerTargeting, null, 2);

      // Rebuild summaryOrder and isSummaryView
      self.summaryOrder = self.getSummaryOrder(); // You’ll need this util
      self.isSummaryView = self.ruleSets.some((rs) =>
          rs.ageChips.length || rs.genderChips.length || rs.geoChips.length
      );
    };

    self.getSummaryOrder = function () {
      const order = [];
      self.ruleSets.forEach((rs) => {
        if (rs.ageChips.length) order.push("Age");
        if (rs.genderChips.length) order.push("Gender");
        if (rs.geoChips.length) order.push("Geo");
      });
      return [...new Set(order)];
    }

    function containsDimension(rule, dimension) {
      if (rule.dimension === dimension) {
        return true;
      }
      if (rule.fields) {
        return rule.fields.some((field) => containsDimension(field, dimension));
      }
      return false;
    }

    // Helper function to check for geo-related rules
    function containsGeo(rule) {
      if (
          rule.dimension &&
          ["country", "region-iso", "city-geonames-id"].includes(rule.dimension)
      ) {
        return true; // Direct match for geo-related dimensions
      }
      if (rule.fields) {
        return rule.fields.some((field) => containsGeo(field)); // Recursively check nested fields
      }
      return false;
    }

    self.toggleGender = function (gender) {
      const ruleSet = self.tempRuleSets[self.currentRuleSetIndex];

      const genderChipIndex = ruleSet.tempGenderChips.findIndex(function (chip) {
        return chip.value.toLowerCase() === gender.toLowerCase();
      });

      if (genderChipIndex === -1) {
        ruleSet.tempGenderChips.push({
          value: gender.charAt(0).toUpperCase() + gender.slice(1),
          match: self.matchType,
        });
      } else {
        ruleSet.tempGenderChips.splice(genderChipIndex, 1);
      }
    };

    self.isGenderSelected = function (gender) {
      const ruleSet = self.tempRuleSets[self.currentRuleSetIndex];
      return ruleSet.tempGenderChips && ruleSet.tempGenderChips.some(chip => chip.value.toLowerCase() === gender.toLowerCase());
    };

    self.createOrSet = () => {
      const newTempSet = {
        tempAgeChips: [],
        tempGenderChips: [],
        tempGeoChips: [],
        ageMatchType: true,
        genderMatchType: true,
        geoMatchType: true
      };

      const newConfirmedSet = {
        ageChips: [],
        genderChips: [],
        geoChips: [],
        ageMatchType: true,
        genderMatchType: true,
        geoMatchType: true
      };

      self.tempRuleSets.push(newTempSet);
      self.ruleSets.push(newConfirmedSet);
      self.currentRuleSetIndex = self.tempRuleSets.length - 1;
      self.openMainDialog();
    };

    self.addAndRule = (index) => {
      self.currentRuleSetIndex = index;
      self.openMainDialog();
    };

    // ************** UTILITY METHODS *****************

    self.copyAllRuleSetsToTemp = () => {
      self.tempRuleSets = self.ruleSets.map((ruleSet) => {
        const tempRuleSet = {};
        Object.keys(ruleSet).forEach((key) => {
          // Copy chips to temp-prefixed keys
          const tempKey = 'temp' + key.charAt(0).toUpperCase() + key.slice(1);
          tempRuleSet[tempKey] = angular.copy(ruleSet[key]);
        });

        if (ruleSet.ageMatchType !== undefined) {
          tempRuleSet.ageMatchType = ruleSet.ageMatchType;
        }
        if (ruleSet.genderMatchType !== undefined) {
          tempRuleSet.genderMatchType = ruleSet.genderMatchType;
        }
        if (ruleSet.geoMatchType !== undefined) {
          tempRuleSet.geoMatchType = ruleSet.geoMatchType;
        }

        return tempRuleSet;
      });
    };

    self.copyAllTempRuleSetsToMain = () => {
      self.ruleSets = self.tempRuleSets.map((tempRuleSet) => {
        const ruleSet = {};
        Object.keys(tempRuleSet).forEach((tempKey) => {
          if (tempKey.startsWith('temp')) {
            const originalKey = tempKey.charAt(4).toLowerCase() + tempKey.slice(5);
            ruleSet[originalKey] = angular.copy(tempRuleSet[tempKey]);
          }
        });

        if (tempRuleSet.ageMatchType !== undefined) {
          ruleSet.ageMatchType = tempRuleSet.ageMatchType;
        }
        if (tempRuleSet.genderMatchType !== undefined) {
          ruleSet.genderMatchType = tempRuleSet.genderMatchType;
        }
        if (tempRuleSet.geoMatchType !== undefined) {
          ruleSet.geoMatchType = tempRuleSet.geoMatchType;
        }

        return ruleSet;
      });
    };

    self.setCurrentIndex = (index) => {
      self.currentRuleSetIndex = index;
    };

    self.hasChipsInCurrentRuleSet = function(targetingType) {
      let currentRuleSet = self.tempRuleSets[self.currentRuleSetIndex];

      if (currentRuleSet) {
        if (targetingType === 'gender') {
          return currentRuleSet.tempGenderChips && currentRuleSet.tempGenderChips.length > 0;
        }
      }

      return false;
    };

    self.deleteSet = function (ruleSetIndex) {
      if (
          !Array.isArray(self.ruleSets) ||
          !self.selectedTritonListenerTargeting ||
          !self.selectedTritonListenerTargeting.rules ||
          !Array.isArray(self.selectedTritonListenerTargeting.rules.fields)
      ) {
        return;
      }

      self.ruleSets.splice(ruleSetIndex, 1);
      self.selectedTritonListenerTargeting.rules.fields.splice(ruleSetIndex, 1);

      if (self.selectedTritonListenerTargeting.rules.fields.length === 0) {
        self.selectedTritonListenerTargeting = {};
        self.ruleSets = [{
          genderChips: [],
          ageChips: [],
          geoChips: [],
          ageMatchType: true,
          genderMatchType: true,
          geoMatchType: true
        }];
        self.tempRuleSets = [{
          tempGenderChips: [],
          tempAgeChips: [],
          tempGeoChips: [],
          ageMatchType: true,
          genderMatchType: true,
          geoMatchType: true
        }];
        self.isSummaryView = false;

        if (
            $rootScope.selectedGeoLocations &&
            $rootScope.selectedGeoLocations.selAdwordsLocationPickers
        ) {
          $rootScope.selectedGeoLocations.selAdwordsLocationPickers = [];
        }
      }
      self.sets = JSON.stringify(self.selectedTritonListenerTargeting, null, 2);
    };


    self.duplicateSet = function (ruleSetIndex) {
      if (
          !Array.isArray(self.ruleSets) ||
          !self.selectedTritonListenerTargeting ||
          !self.selectedTritonListenerTargeting.rules ||
          !Array.isArray(self.selectedTritonListenerTargeting.rules.fields)
      ) {
        return;
      }

      const originalRuleSet = self.ruleSets[ruleSetIndex];
      const originalRuleField = self.selectedTritonListenerTargeting.rules.fields[ruleSetIndex];

      const clonedRuleSet = {
        ageChips: angular.copy(originalRuleSet.ageChips),
        genderChips: angular.copy(originalRuleSet.genderChips),
        geoChips: angular.copy(originalRuleSet.geoChips),
      };

      const clonedRuleField = angular.copy(originalRuleField);

      self.ruleSets.splice(ruleSetIndex + 1, 0, clonedRuleSet);
      self.selectedTritonListenerTargeting.rules.fields.splice(ruleSetIndex + 1, 0, clonedRuleField);

      self.sets = JSON.stringify(self.selectedTritonListenerTargeting, null, 2);
    };

    self.addGeoChips = function (geoLocations, match = self.matchType) {
      const tempRuleSet = self.tempRuleSets[self.currentRuleSetIndex];
      if (!tempRuleSet) return;

      if (!tempRuleSet.tempGeoChips) {
        tempRuleSet.tempGeoChips = [];
      }

      geoLocations.forEach(function (location) {
        const chipUniqueKey = self.generateUniqueKey(location);

        if (
            !tempRuleSet.tempGeoChips.some(function (chip) {
              return chip.uniqueKey === chipUniqueKey;
            })
        ) {
          tempRuleSet.tempGeoChips.push({
            value: self.formatChipDisplay(location),
            country_code: location.country_code,
            type: location.type,
            value_num: location.value,
            code: location.code,
            match: match,
            uniqueKey: chipUniqueKey,
          });
        }
      });
    };

    self.generateUniqueKey = function (location) {
      let key = "";

      if (location.parent_country_name || location.parent_name) {
        key += `${
            location.parent_country_name || location.parent_name
        } (Country) > `;
      }

      if (location.parent_region_name) {
        key += `${location.parent_region_name} (Region) > `;
      }

      key += `${location.name} (${location.type})`;

      return key;
    };

    self.formatChipDisplay = function (location) {
      let display = "";

      if (location.parent_country_name || location.parent_name) {
        display += `${
            location.parent_country_name || location.parent_name
        } (Country) > `;
      }

      if (location.parent_region_name) {
        display += `${location.parent_region_name} (Region) > `;
      }

      display += `${location.name} (${location.type})`;

      return display;
    };

    self.removeGeoChip = function (index) {
      const tempRuleSet = self.tempRuleSets[self.currentRuleSetIndex];
      if (!tempRuleSet || !tempRuleSet.tempGeoChips) return;

      const chipToRemove = tempRuleSet.tempGeoChips[index];

      let matchedItem = $rootScope.selectedGeoLocations.selAdwordsLocationPickers.find(
          (locationPicker) => {
            return (
                (locationPicker.type === undefined ||
                    chipToRemove.type === undefined ||
                    locationPicker.type === chipToRemove.type) &&
                (locationPicker.value === undefined ||
                    chipToRemove.value_num === undefined ||
                    locationPicker.value === chipToRemove.value_num) &&
                (locationPicker.country_code === undefined ||
                    chipToRemove.country_code === undefined ||
                    locationPicker.country_code === chipToRemove.country_code) &&
                (locationPicker.code === undefined ||
                    chipToRemove.code === undefined ||
                    locationPicker.code === chipToRemove.code)
            );
          }
      );

      if (matchedItem) {
        $rootScope.removeLoc(matchedItem);
      }

      tempRuleSet.tempGeoChips.splice(index, 1);
    };

    $scope.$watch(
        function () {
          return $rootScope.selectedGeoLocations
              ? $rootScope.selectedGeoLocations.selAdwordsLocationPickers
              : undefined;
        },
        function (newValue, oldValue) {
          if (newValue !== oldValue) {
            if (newValue) {
              self.addGeoChips(newValue || []);
              self.updateTargetingPayload("geo", newValue);
            }
          }
        },
        true
    );

    $scope.$watch(
        function () {
          return $rootScope.selectedGeoLocations
              ? $rootScope.selectedGeoLocations.selAdwordsLocationPickers
              : undefined;
        },
        function (newValue) {
          if (Array.isArray(newValue) && newValue.length === 0) {
            var parsedSets = {};
            try {
              // Parse self.sets if it's a string; otherwise, use it as is
              parsedSets =
                  typeof self.sets === "string"
                      ? JSON.parse(self.sets)
                      : self.sets;

              // Ensure parsedSets is a valid object
              if (parsedSets && typeof parsedSets === "object") {
                // Check if selectedGeoLocations exists and is an array
                if (Array.isArray(parsedSets.selectedGeoLocations)) {
                  // Initialize $rootScope.selectedGeoLocations if it doesn't exist
                  if (!$rootScope.selectedGeoLocations) {
                    $rootScope.selectedGeoLocations = {};
                  }

                  // Assign selectedGeoLocations to $rootScope
                  $rootScope.selectedGeoLocations.selAdwordsLocationPickers =
                      angular.copy(parsedSets.selectedGeoLocations);
                }
              }
            } catch (e) {
              parsedSets = {}; // Fallback to an empty object
            }
          }
        },
        true
    );

    self.editKey = function (index, key) {
      self.setCurrentIndex(index);

      if (key === "Age") {
        self.openAgeDialog();
      } else if (key === "Gender") {
        self.openGenderDialog();
      } else if (key === "Geo") {
        self.openGeoDialog();
      }
    };

    self.initializeChips = function () {
      self.ruleSets = [];

      let parsedSets;
      try {
        parsedSets = JSON.parse(self.sets);
      } catch (e) {
        return;
      }

      if (!parsedSets.rules || !parsedSets.rules.fields) {
        return;
      }

      parsedSets.rules.fields.forEach(function (orGroup) {
        if (orGroup.type === "and") {
          const newRuleSet = {
            genderChips: [],
            ageChips: [],
            geoChips: [],
            genderMatchType: true,
            ageMatchType: true,
            geoMatchType: true,
          };

          orGroup.fields.forEach(function (andBlock) {
            if (andBlock.type === "and") {
              andBlock.fields.forEach(function (ruleBlock) {
                let ruleToProcess = ruleBlock;
                let match = true;

                if (ruleBlock.type === "not" && ruleBlock.field) {
                  ruleToProcess = ruleBlock.field;
                  match = false;
                }

                if (ruleToProcess.dimension === "gender") {
                  if (Array.isArray(ruleToProcess.values) && ruleToProcess.values.length > 0) {
                    ruleToProcess.values.forEach(function (value) {
                      let genderLabel = "";
                      switch (value.toLowerCase()) {
                        case "m":
                          genderLabel = "Male";
                          break;
                        case "f":
                          genderLabel = "Female";
                          break;
                        case "o":
                          genderLabel = "Other";
                          break;
                        default:
                          genderLabel = "Unknown";
                      }

                      newRuleSet.genderChips.push({ match, value: genderLabel });
                    });

                    // Set genderMatchType based on first match flag encountered
                    newRuleSet.genderMatchType = match;

                    if (!self.summaryOrder.includes("Gender")) {
                      self.summaryOrder.push("Gender");
                    }
                  }
                }

                if (ruleToProcess.type === "or" && ruleToProcess.fields) {
                  ruleToProcess.fields.forEach(function (field) {
                    if (field.dimension === "age") {
                      let chipValue = "";
                      let rule = "";

                      if (field.type === "equals") {
                        chipValue = field.value;
                        rule = "is";
                      } else if (field.type === "bound") {
                        if (field.lower !== undefined && field.upper !== undefined) {
                          chipValue = `${field.lower} - ${field.upper}`;
                          rule = "between";
                        } else if (field.lower !== undefined) {
                          chipValue = ` ${field.lower}`;
                          rule = "gte";
                        } else if (field.upper !== undefined) {
                          chipValue = ` ${field.upper}`;
                          rule = "lte";
                        }
                      }

                      newRuleSet.ageChips.push({ value: chipValue, match, rule });

                      // Set ageMatchType based on first match flag encountered
                      newRuleSet.ageMatchType = match;

                      if (!self.summaryOrder.includes("Age")) {
                        self.summaryOrder.push("Age");
                      }
                    }

                    const geoDimensions = ["country", "region-iso", "city-geonames-id"];

                    if (geoDimensions.includes(field.dimension)) {
                      if (Array.isArray(field.values) && field.values.length > 0) {
                        field.values.forEach(function () {
                          if (parsedSets.selectedGeoLocations) {
                            self.addGeoChips(parsedSets.selectedGeoLocations, match);

                            const geoChips = [];
                            parsedSets.selectedGeoLocations.forEach(function (location) {
                              geoChips.push({
                                value: self.formatChipDisplay(location),
                                country_code: location.country_code,
                                type: location.type,
                                value_num: location.value,
                                code: location.code,
                                match: match,
                                uniqueKey: self.generateUniqueKey(location),
                              });
                            });

                            newRuleSet.geoChips = geoChips;

                            // Set geoMatchType based on match
                            newRuleSet.geoMatchType = match;

                            if (!$rootScope.selectedGeoLocations) {
                              $rootScope.selectedGeoLocations = {};
                            }

                            $rootScope.selectedGeoLocations.selAdwordsLocationPickers =
                                parsedSets.selectedGeoLocations;
                          }
                        });
                      }

                      if (!self.summaryOrder.includes("Geo")) {
                        self.summaryOrder.push("Geo");
                      }
                    }
                  });
                }
              });
            }
          });

          if (
              newRuleSet.genderChips.length ||
              newRuleSet.ageChips.length ||
              newRuleSet.geoChips.length
          ) {
            self.ruleSets.push(newRuleSet);
          }
        }
      });
    };

    self.isAllRuleSetsEmpty = function () {
      if (!self.ruleSets || !self.ruleSets.length) return true;

      return self.ruleSets.every(function (set) {
        return !set.ageChips.length && !set.genderChips.length && !set.geoChips.length;
      });
    };

    self.removeExtraGeoChips = function () {
      const tempRuleSet = self.tempRuleSets[self.currentRuleSetIndex];
      const ruleSet = self.ruleSets[self.currentRuleSetIndex];

      if (!tempRuleSet || !ruleSet) return;

      const indexesToRemove = tempRuleSet.tempGeoChips
          .map((chip, index) => {
            const matchFound = ruleSet.geoChips.some((geoChip) => {
              return (
                  geoChip.country_code === chip.country_code &&
                  geoChip.type === chip.type &&
                  geoChip.value_num === chip.value_num &&
                  geoChip.code === chip.code &&
                  geoChip.uniqueKey === chip.uniqueKey
              );
            });
            return matchFound ? null : index;
          })
          .filter((index) => index !== null);

      indexesToRemove.forEach((index) => self.removeGeoChip(index));
    };

    self.initComponent = function () {
      if (self.sets && self.sets.length > 0) {
        if (
            self.selectedTritonListenerTargeting &&
            self.selectedTritonListenerTargeting.length > 0
        ) {
          self.sets = self.selectedTritonListenerTargeting;
        } else {
          self.selectedTritonListenerTargeting = JSON.parse(self.sets);
        }

        self.editMode = false;
        self.enableViewMode = true;
        self.isSummaryView = true;
        self.isMainDialogOpen = false;
        self.isAgeDialogOpen = false;
        self.isGenderDialogOpen = false;
        self.sets = self.sets;
        self.initializeChips();
      } else {
        self.enableViewMode = false;
        self.isSummaryView = false;
        self.isMainDialogOpen = false;
        self.isAgeDialogOpen = false;
        self.isGenderDialogOpen = false;
        self.editMode = false;
        self.sets = [{}];
      }
    };

    self.initComponent();
  },
});
